import React from "react";
import { useTranslation } from "react-i18next";

import * as SC from "./TargetMetric.styled";

const TargetMetric = ({ minTarget, totalTarget }) => {
  const { t } = useTranslation();

  const hasMinTarget = minTarget != null;
  const isTargetAchieved = totalTarget >= minTarget;
  const targetTitle = isTargetAchieved ? t("Target Achieved") : t("Target Missed");

  return (
    <SC.TargetBox isTargetAchieved={isTargetAchieved} hasMinTarget={hasMinTarget}>
      {hasMinTarget && (
        <SC.TargetTitle isTargetAchieved={isTargetAchieved}>{targetTitle}</SC.TargetTitle>
      )}
      <SC.TargetValue>{minTarget}</SC.TargetValue>
    </SC.TargetBox>
  );
};

export default TargetMetric;
